import type { ComputedRef, InjectionKey } from 'vue'

import type { WidgetValue } from '@/types/simplifiedWidget'

export interface SettingBindingContext {
  widgetName: string
  widgetType: string
  value: ComputedRef<WidgetValue>
  setValue: (value: WidgetValue) => void
}

export const SettingBindingKey: InjectionKey<SettingBindingContext> =
  Symbol('miniflow-setting-binding')

export const SETTING_PLACEHOLDER_RE = /^\[settings\.(.+)\]$/

const BINDABLE_WIDGET_TYPES = new Set([
  'string',
  'text',
  'password',
  'number',
  'int',
  'float',
  'combo',
  'toggle',
  'boolean'
])

export function isBindableWidgetType(type: string): boolean {
  return BINDABLE_WIDGET_TYPES.has(type)
}

export function boundSettingKey(value: WidgetValue): string | null {
  if (typeof value !== 'string') return null
  const match = SETTING_PLACEHOLDER_RE.exec(value)
  return match ? match[1] : null
}

export function settingPlaceholder(key: string): string {
  return `[settings.${key}]`
}
